import { render, staticRenderFns } from "./addOrg.vue?vue&type=template&id=7e450866"
import script from "./addOrg.vue?vue&type=script&lang=js"
export * from "./addOrg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports